export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_04_alt_loop.729d5658.mp4";